import type { SVGProps } from "react";
export interface FolderBannedIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FolderBannedIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FolderBannedIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 18V6A4.125 4.125 0 0 1 5 1.875h4.586c.493 0 .969.172 1.347.482l.155.14 2.377 2.378H19A4.125 4.125 0 0 1 23.125 9v2.065a1.125 1.125 0 0 1-2.25 0V9c0-1.036-.84-1.875-1.875-1.875h-5.586c-.493 0-.968-.172-1.346-.482l-.157-.14-2.377-2.378H5c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h5.587l.114.006a1.125 1.125 0 0 1 0 2.238l-.114.006H5A4.125 4.125 0 0 1 .875 18"
      />
      <path
        fill={color}
        d="M20.875 18a2.875 2.875 0 0 0-3.95-2.665l3.74 3.74c.134-.333.21-.695.21-1.075m-5.75 0a2.875 2.875 0 0 0 3.95 2.665l-3.74-3.74c-.135.332-.21.695-.21 1.075m8 0a5.124 5.124 0 1 1-10.249 0 5.124 5.124 0 0 1 10.249 0"
      />
    </svg>
  );
}
